var map = {
	"./CHECKING-e.png": "84794",
	"./CHECKING-f.png": "5d30",
	"./CHECKING.png": "4f66",
	"./CLOSE-e.png": "3ef1",
	"./CLOSE-f.png": "4472",
	"./CLOSE.png": "ebde",
	"./FOREX@2x.png": "d965",
	"./FUND@2x.png": "a260",
	"./FUTURES@2x.png": "d1ee",
	"./OPEN-e.png": "b080",
	"./OPEN-f.png": "68cc",
	"./OPEN.png": "db65",
	"./PM@2x.png": "88f1",
	"./REJECT-e.png": "80b8",
	"./REJECT-f.png": "c688",
	"./REJECT.png": "5517",
	"./STOCK@2x.png": "d48e",
	"./STOP-e.png": "c802",
	"./STOP-f.png": "8e02",
	"./STOP.png": "ac8a",
	"./aggressive.png": "0b90",
	"./balance.png": "54f1",
	"./conservative.png": "e75f",
	"./growth.png": "c2d7",
	"./icon_submit.png": "5f9a",
	"./quotation.png": "d958",
	"./risklevelR1.png": "a205",
	"./risklevelR2.png": "874d",
	"./risklevelR3.png": "4cce",
	"./risklevelR4.png": "6086",
	"./risklevelR5.png": "9071",
	"./robust.png": "fbb1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0642";